import {
  CustomerBankAccountMandateStateEnumType,
  Maybe,
  B2BPaymentMethod,
  PaymentMethodState,
} from "@oysterhr/schema"
import { Alert } from "@oysterhr/ui"
import { useTranslation } from "react-i18next"
import { PaymentMethodEnumType } from "~/app/utils/constants"

interface VerifyingAlertProps {
  paymentMethod?: Maybe<B2BPaymentMethod>
}

export const VerifyingAlert = ({ paymentMethod }: VerifyingAlertProps) => {
  const { t } = useTranslation("company_interface/CompanyPaymentMethodsPage/SepaFlow", {
    keyPrefix: "alerts",
  })

  // We're in verifying state if payment method is authorized by user and mandate is lodged
  if (
    !paymentMethod ||
    paymentMethod.state !== PaymentMethodState.AuthorizedByUser ||
    (paymentMethod.__typename === PaymentMethodEnumType.CUSTOMER_BANK_ACCOUNT_SEPA &&
      paymentMethod?.mandate?.state !== CustomerBankAccountMandateStateEnumType.Lodged)
  )
    return null

  return (
    <Alert variation="info">
      <Alert.Icon />
      <Alert.Content>{t("verifying.content")}</Alert.Content>
    </Alert>
  )
}
